import {Country} from "../defs/country";
import {CountryGroup} from "../defs/group";

export const Mauritius: Country = {
    identifier: "Mauritius",
    name: "Mauritius",
    countryCode: "MU",
    group: CountryGroup.AFRICA,
    isUNMember: true,
    flag: "🇲🇺",
    svgPath: "m 636.69275,521.3014 -0.354,0.084 -0.398,-0.029 -0.154,-0.159 -0.03,-0.067 0.133,-0.063 -0.008,-0.205 0.066,-0.324 0.085,-0.133 0.197,-0.119 0.081,-0.261 0.17,-0.174 0.227,-0.022 0.226,0.322 0.154,0.339 -0.032,0.341 -0.156,0.124 -0.052,0.197 z",
}
